import React from "react";
import {useTranslation} from "react-i18next";


function Nav() {
    const {t} = useTranslation()
    return (
        <div className="nav row my-3">
            <div className="col-1">
                <img className="logo" src={require("../img/logo.jpg")} alt="OTT_logo" width={80}/>
                <br/>
            </div>
            <div className="col-10 text-center">
                <h2>{t('top_biocollection_name')}</h2>
            </div>

            <div className="col-1"></div>
        </div>
    )
}

export default Nav;